import { z } from 'zod'

export const PRACTICE_SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/

export const practiceAddressSchema = z.object({
  street: z.string().min(1, 'Street address is required'),
  city: z.string().min(1, 'City is required'),
  state: z.string().min(1, 'State is required'),
  zip: z.string().min(1, 'ZIP code is required'),
})

export const practiceProfileStepDataSchema = z.object({
  name: z.string().min(1, 'Practice name is required'),
  address: practiceAddressSchema,
  phone: z.string().min(1, 'Phone is required'),
  slug: z
    .string()
    .min(3, 'Slug must be at least 3 characters')
    .max(40, 'Slug must be at most 40 characters')
    .regex(PRACTICE_SLUG_PATTERN, 'Use lowercase letters, numbers, and hyphens only'),
})

export type PracticeProfileStepData = z.infer<typeof practiceProfileStepDataSchema>

export function slugFromName(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
}
